<template>
    <div class="p-register-card ">
        <div class="register-card" v-if="showForm || showDesktop">
            <i class="mobile-only icon icon-round-close" @click="toggleShowMobileRegister"></i>
            <h1 class="title desktop-only" v-html="boxTitle" />
            <h5 class="sub-title desktop-only" v-html="boxSlogan" />
            <form autocomplete="off" @submit.prevent="submit">
                <div :class="`form-con ${showDesktop ? 'form-inline' : ''}`">
                    <div class="form-group">
                        <label>{{ 'I am a' | translate }}</label>
                        <div class="select-wrapper">
                            <select class="form-control" v-model="preference">
                                <option v-for="(val, key) in preferences" :value="val.value" :key="key">{{ val.label }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="form-group">
                        <label>{{ locationText }}</label>
                        <div class="province-country-select-wrapper">
                            <div class="select-wrapper" v-if="countries.length >= 2">
                                <select class="form-control" ref="select-country" v-model="country" @change="loadProvinces()">
                                    <option :disabled="val.id!==country && (val.disabled || false)" v-for="(val, key) in countries" :value="val.id" :key="key">{{ val.name }}</option>
                                </select>
                            </div>
                            <div class="select-wrapper">
                                <select class="form-control" ref="select-province" v-model="province">
                                    <option v-for="(val, key) in provinces" :value="val.id" :key="key">{{ val.name }}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="desktop-only">&nbsp;</label>
                        <div class="input-wrapper">
                            <button v-if="showDesktop" class="btn btn-colored" :disabled="loading">
                                <span>{{ 'Join now' | translate | normalize }}</span>
                            </button>
                            <button v-else class="btn btn-colored" :disabled="loading" @click.prevent="submit">
                                <span v-html="boxButton" />
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
        <slot ref="slot"></slot>
    </div>
</template>

<script>
    import PRegisterCard from '@views/public/partials/PRegisterCard/p_register_card'

    export default {
        mixins: [PRegisterCard],
        components: {

        }
    }

</script>

<style lang="scss" src="./p_register_card.scss"></style>
